export default "__VITE_ASSET__Bptod721__"